import { apiRequest } from "../api";

export interface OrganizationTagRow {
  _id: string;
  name: string;
}

export const organizationTagsService = {
  async list(): Promise<[string[] | null, unknown]> {
    const [data, err] = await apiRequest<{ result: string[] }>({
      loaderKey: "organizationTags",
      method: "get",
      url: "/app/tags",
    });
    if (err || !data) return [null, err];
    return [data.result || [], null];
  },

  async create(name: string): Promise<[{ name: string } | null, unknown]> {
    return apiRequest<{ name: string }>({
      loaderKey: "organizationTagCreate",
      method: "post",
      url: "/app/tags",
      data: { name },
    });
  },

  /** Lista com id — usado na tela de gerenciamento (renomear/apagar). */
  async listManage(): Promise<[OrganizationTagRow[] | null, unknown]> {
    const [data, err] = await apiRequest<{ result: OrganizationTagRow[] }>({
      loaderKey: "organizationTagsManage",
      method: "get",
      url: "/app/tags/manage",
    });
    if (err || !data) return [null, err];
    return [data.result || [], null];
  },

  /** Propaga o novo nome pra contatos/tickets/empresas que já usam a tag. */
  async rename(id: string, name: string): Promise<[{ name: string } | null, unknown]> {
    return apiRequest<{ name: string }>({
      loaderKey: "organizationTagRename",
      method: "put",
      url: `/app/tags/${id}`,
      data: { name },
    });
  },

  /** Remove também de contatos/tickets/empresas que já usam a tag. */
  async remove(id: string): Promise<[{ msg: string } | null, unknown]> {
    return apiRequest<{ msg: string }>({
      loaderKey: "organizationTagRemove",
      method: "delete",
      url: `/app/tags/${id}`,
    });
  },
};
